import React from "react";
import PropTypes from "prop-types";
import { FaArrowRight } from "@react-icons/all-files/fa/FaArrowRight";
import { imagePrettyUrl } from "~helpers/getters";
import LazyImage from "~hooks/lazy-image";
import BonusBox from "~molecules/bonus-box/template-four";
import OperatorCta from "~atoms/button/operator-cta";
import Rating from "~molecules/star-rating/one-star";
import Tnc from "~molecules/tnc";
import PrettyLink from "~atoms/pretty-link";
import { TrackingKeys } from '~constants/tracking-api'
import styles from "./bonus.module.scss";
import Ribbons from "../../../atoms/ribbons";

export default function Bonus({
  operator,
  pageTemplate,
  moduleName = TrackingKeys?.BONUS,
  module = {},
  tncFixed = false,
  width = 120,
  height = 120,
  showRoundedRating = false,
  showRatingLabel = false,
  showLabelMiddle = false,
  ctaIcon = <FaArrowRight fontSize={20} title="Right-pointing Arrow Icon" />,
  modulePosition,
  showRibbon = false,
}) {
  
  const { logo, bonus, name } = operator || {};
  return (
    <div className={`${styles.operatorBanner || ""}`}>
      <div className={styles.container}>
        {showRibbon && <Ribbons item={operator.ribbons} />}
        <div>
          <PrettyLink
            operator={operator}
            pageTemplate={pageTemplate}
            moduleName={moduleName}
            tracker={module?.tracking_link_name || "main"}
            clickedElement="operator_logo"
            className={`${styles.logo || ""} operator-banner-gtm logo-cta`}
            modulePosition={modulePosition}
          >
            <LazyImage
              alt={operator?.name}
              src={imagePrettyUrl(logo?.filename, width, height)}
              height={height}
              width={width}
            />
            <div className={styles.details}>
              {(bonus?.operator_name || name) && (
                <span>{bonus?.operator_name || name}</span>
              )}
              {(operator?.rating || bonus?.rating) && (
                <Rating
                  rating={operator.rating || bonus?.rating}
                  showDecimal
                  showLabel={showRatingLabel}
                  showLabelMiddle={showLabelMiddle}
                  showRoundedRating={showRoundedRating}
                />
              )}
            </div>
          </PrettyLink>
          <div className={styles.bonus || ""}>
            <BonusBox
              item={operator}
              moduleName={moduleName}
              pageTemplate={pageTemplate}
              tracker={module?.type || "main"}
              modulePosition={modulePosition}
            />
            {!tncFixed && <Tnc isFixed={tncFixed} operator={operator} />}
          </div>
          <OperatorCta
            operator={operator}
            pageTemplate={pageTemplate}
            tracker={module?.tracking_link_name || "main"}
            moduleName={moduleName}
            icon={ctaIcon}
            modulePosition={modulePosition}
          />
        </div>
        {tncFixed && <Tnc isFixed={tncFixed} operator={operator} />}
      </div>
    </div>
  );
}

Bonus.propTypes = {
  operator: PropTypes.shape({
    logo: PropTypes.shape({}),
    bonus: PropTypes.shape({
      rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    name: PropTypes.string,
    rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    url: PropTypes.string,
    extra_fields: PropTypes.shape({
      terms_and_conditions_text_enabled: PropTypes.string,
    }),
    status: PropTypes.string,
    ribbons: PropTypes.arrayOf(PropTypes.string),
  }),
  tncFixed: PropTypes.bool,
  pageTemplate: PropTypes.string,
  moduleName: PropTypes.string,
  module: PropTypes.shape({
    tracking_link_name: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
  }),
  width: PropTypes.number,
  height: PropTypes.number,
  showRoundedRating: PropTypes.bool,
  showRatingLabel: PropTypes.bool,
  showLabelMiddle: PropTypes.bool,
  ctaIcon: PropTypes.elementType,
  modulePosition: PropTypes.number,
  showRibbon: PropTypes.bool,
};
